var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backContainer"},[_c('div',{staticClass:"btnBack ripple",on:{"click":function($event){$event.preventDefault();return _vm.volver()}}},[_c('fai',{attrs:{"icon":"arrow-left"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }